module.exports = __webpack_public_path__ + "static/media/linkedin.eef5d922.svg";